<section class="referral-how-it-works">
  <h2 class="referral-how-it-works__title semi-bold">How it works</h2>
  <p class="referral-how-it-works__subtitle">A simple way to share travel and earn rewards</p>

  <ol class="referral-how-it-works__steps">
    <li class="referral-how-it-works__step">
      <span class="referral-how-it-works__step-num" aria-hidden="true">1</span>
      <p class="referral-how-it-works__step-title semi-bold">Share your invite link</p>
      <p class="referral-how-it-works__step-text">Send your personal link to friends or family</p>
    </li>
    <li class="referral-how-it-works__step">
      <span class="referral-how-it-works__step-num" aria-hidden="true">2</span>
      <p class="referral-how-it-works__step-title semi-bold">
        They book within {{ bookingMonths }} months
      </p>
      <p class="referral-how-it-works__step-text">
        Your friend gets {{ rewardAmount | portalCurrency: true }} in travel credit to book a flight
        within {{ bookingMonths }} months. They can travel later
      </p>
    </li>
    <li class="referral-how-it-works__step">
      <span class="referral-how-it-works__step-num" aria-hidden="true">3</span>
      <p class="referral-how-it-works__step-title semi-bold">You earn your reward</p>
      <p class="referral-how-it-works__step-text">
        Earn up to {{ rewardAmount | portalCurrency: true }} after they complete their journey
      </p>
    </li>
  </ol>

  <p class="referral-how-it-works__terms">Referral Program Terms &amp; Conditions</p>
</section>
